function serialize (dataviewsCollection) {
  return dataviewsCollection.reduce(function (dataviews, dataviewModel) {
    dataviews[dataviewModel.get('id')] = dataviewModel.toJSON();
    return dataviews;
  }, {});
}

module.exports = {
  serialize: serialize
};



//////////////////
// WEBPACK FOOTER
// ./~/internal-carto.js/src/windshaft/map-serializer/anonymous-map-serializer/dataviews-serializer.js
// module id = 1716
// module chunks = 6